module.exports = __webpack_public_path__ + "static/media/marriage-5.203c81af.jpg";